import script from "./CustomFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFilters.vue?vue&type=script&setup=true&lang=js"

import "./CustomFilters.vue?vue&type=style&index=0&id=71a2a60a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a2a60a"]])

export default __exports__